import { TextArea } from "@portal/BaseComponents/Input/AntInput";
import { Select } from "@portal/BaseComponents/Select/AntSelect";
import { onSelectChange } from "@portal/BaseComponents/Select/type";

import { OnTextAreaChange } from "@portal/BaseComponents/Input/type";
import { DocumentTypes } from "@portal/types/entities/documents";
import { PageList } from "@portal/types/page-list";
import { useMemo, useState } from "react";
import { mapDocumentTypesOptionPredicate } from "./predicate";
import { AddDocDefaultFormElementProps } from "./type";

interface DocumentTypesFormProps
  extends AddDocDefaultFormElementProps<string[], string[]> {
  options?: PageList<DocumentTypes, unknown>["list"];
}
function DocumentTypesForm(props: DocumentTypesFormProps) {
  const { value: defaultValues, onChange, options: option } = props;

  const [selectedValues, setSelectedValues] = useState<string[] | undefined>(
    defaultValues
  );

  function getDocumentTypesOption() {
    if (!option) return [];
    return option.map(mapDocumentTypesOptionPredicate);
  }

  const options = useMemo(getDocumentTypesOption, [option]);

  function handleChange(...args: onSelectChange<string[]>) {
    const [value] = args;
    setSelectedValues(value);
    onChange?.(value);
  }

  return (
    <Select<string[]>
      optionLabelProp="label"
      optionFilterProp="label"
      defaultValue={selectedValues}
      options={options}
      showSearch
      onChange={handleChange}
    />
  );
}

function DocumentDetailsForm(
  props: AddDocDefaultFormElementProps<string, string>
) {
  const { value: selectedValue, onChange } = props;
  function handleChange(event: OnTextAreaChange[number]) {
    onChange?.(event.target.value);
  }
  return (
    <TextArea
      onChange={handleChange}
      defaultValue={selectedValue}
      autoSize={{ minRows: 5, maxRows: 9 }}
    />
  );
}

export { DocumentDetailsForm, DocumentTypesForm };
